import { INavigation } from './interfaces/navigation'

export default class Navigation implements INavigation {
  public currentStep = 1
  public totalSteps = 7
  public highestVisitedStep = 1
  public isLoading = false
}
